import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../tailwind.config';
// eslint-disable-next-line
export function getTailwindConfig(): any {
  // eslint-disable-next-line
  return resolveConfig(tailwindConfig as any);
}
